 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		110: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		110: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"14":"ExamBoostAnimation","15":"NoWrongAnswersAnimation","16":"quiz-animation","17":"transfer-subscription-no-children-animation","27":"ChatbotQuitAnimation","28":"ChatbotTypingAnimation","29":"FloralRewardAnimation","30":"NoClassesAnimation","31":"SenecaPremiumCardAnimation","32":"accept-challenge-animation","33":"adam-image","34":"all-child-assignments","35":"anonymous-course-discovery-chunk","36":"anonymous-resources-hub","37":"anonymous-resources-hub-chunk","38":"anonymous-what-is-premium-parent","39":"anonymous-what-is-premium-teacher","40":"assignment-complete-animation","41":"assignment-share-animation","42":"ben-image","43":"calendar-image","44":"car-animation","45":"child-connected-modal","46":"child-connection-invite-journey","47":"child-not-found-route","48":"child-overview-page","49":"child-single-assignment","50":"child-sub-router","51":"circle-books-animation","52":"claim-tutoring-journey","53":"class-page-router","54":"classes-page","55":"classroom-chunk","56":"clock-animation","57":"confetti-animation","58":"correct-answer-animation","59":"courses-page","60":"courses-page-chunk","61":"creation-chunk","62":"cute-whale-animation","63":"dashboard-router-chunk","64":"date-fns-de","65":"date-fns-de-AT","66":"date-fns-en-AU","67":"date-fns-en-GB","68":"date-fns-en-IN","69":"date-fns-en-US","70":"date-fns-es","71":"date-fns-fr","72":"date-fns-pt-BR","73":"date-fns-vi","74":"dev-tools","75":"empty-desk-animation","76":"falling-confetti-animation","77":"feedback-success-animation","78":"front-door-chunk","79":"get-premium-chunk","80":"gostudent-logo-animation","81":"invite-all-school-parents","82":"invite-classes-parents-animation","83":"jane-image","84":"join-group-animation","85":"link-animation","86":"loading-blocks-animation","87":"magnifying-glass-animation","89":"medal-animation","90":"mia-image","91":"mobile-auth","92":"more-sub-router","93":"mumsnet-image","94":"new-courses-chunk","95":"no-assignments-animation","96":"no-course-info-animation","97":"no-study-time-animation","98":"noStudentsAssignmentsAnimation","99":"parent-claim-tutoring-journey-routes","100":"parent-dashboard","101":"parent-tutoring-page","102":"parent-what-is-premium-page","103":"parents-invite-route","104":"personalised-suggestions-courses-chunk","105":"plug-in-failed-animation","106":"plurall-help-centre-modal-chunk","107":"podium-animation","108":"progress-page","109":"receive-gift-open-animation","111":"sad-look-animation","112":"section-preview","113":"session","114":"settings-page","115":"share-animation","116":"share-assignment-chunk","117":"sign-up-invite-chunk","118":"sleepy-animation","119":"smiling-with-hearts-animation","120":"speedyMarkingQuitAnimation","121":"speedyMarkingSuccessAnimation","122":"spinning-trophy-animation","123":"success-animation","124":"target-animation","125":"teacher-dashboard","126":"topic-score-animation","127":"transfer-subscription-error-animation","128":"transfer-subscription-success-animation","129":"trash-animation","130":"trophy-animation","131":"trustpilot-image","132":"try-a-module","133":"tutoring-activation-journey","134":"unlock-dark-mode-chunk","135":"weekly-reports-page","136":"what-is-premium-chunk","137":"workout-animation"}[chunkId]||chunkId) + "." + {"0":"54356a5e","1":"de6e6561","2":"59fdd0e9","3":"cf8fee91","4":"e8171383","5":"423db013","6":"2e51b75d","7":"d32d5c1c","8":"6409ab09","9":"7a1ddda3","10":"0cb1a7e9","11":"fb5564e7","12":"ba4cca51","13":"5e44ad2b","14":"19127725","15":"e3d57da6","16":"720affc3","17":"0e4773c2","18":"1cc738c0","19":"b70f7e01","20":"d5e8da8d","21":"7ba08dcc","22":"af9637ee","23":"1e58aa53","24":"d057cec2","25":"2752aa28","26":"8b405ca3","27":"9640f0af","28":"919ba2aa","29":"077f5626","30":"bfd37ea1","31":"d4ff39e0","32":"4ef15325","33":"bb5412f3","34":"beeddca5","35":"ac1efa1f","36":"0960bc5b","37":"96c6dd90","38":"db31102c","39":"3f6b7519","40":"eb72b52e","41":"c3ce5a0f","42":"ad867ba7","43":"f3c059db","44":"42e367cb","45":"441219ed","46":"3176a419","47":"16315481","48":"939ef93c","49":"d0398a4b","50":"92caf4d4","51":"e023129f","52":"657f00f3","53":"1876ec32","54":"93b8ae13","55":"20833d3c","56":"e0e5c1aa","57":"5f603f1d","58":"e894e3c2","59":"2fb76677","60":"53ba86bb","61":"9846ec11","62":"fbf14655","63":"a7cd89ab","64":"6ec6bf93","65":"c121c22c","66":"49029647","67":"b61baa88","68":"873e6f77","69":"fc5ddb97","70":"1093e3e3","71":"ccd0f2e9","72":"5f552972","73":"497e80da","74":"5b91218d","75":"4ca945fb","76":"86a721c8","77":"0416b808","78":"0d13678a","79":"047939cb","80":"aa7cdd12","81":"dc32d33c","82":"48f3ffcf","83":"86b64c45","84":"75c5d07d","85":"4635c37e","86":"1bb32206","87":"85504a18","89":"3907396a","90":"e1212416","91":"a090abee","92":"acf2d0ad","93":"c28c3dfa","94":"ce0289cc","95":"53943061","96":"e5efabe2","97":"02407c3e","98":"2164eab3","99":"90a6f8e9","100":"2bfd2fe5","101":"34c39ffd","102":"0c598d6d","103":"6330cadd","104":"ebf7788e","105":"f953dbb5","106":"fef01797","107":"8b8d1a2f","108":"52973fdc","109":"7a5ec086","111":"16660d62","112":"9842d28c","113":"5e3fbf68","114":"6d483c97","115":"205bd9f9","116":"7e815a5b","117":"577dd3db","118":"ee94c5d1","119":"5c35f56e","120":"b5dcb834","121":"d402ca99","122":"f820d9fc","123":"0b3fa46c","124":"75bd831b","125":"1feffc52","126":"f01aa614","127":"a66a7ef0","128":"19626806","129":"6d2da096","130":"f243ce00","131":"eed8420e","132":"553624d6","133":"3e4980c9","134":"e9676105","135":"df561450","136":"8138a74b","137":"54e667eb","139":"3db22ca3","140":"250555d1","141":"0f0a66ef","142":"b3818874","143":"9f01766c","144":"f4cadfd5","145":"0175c3b2","146":"da530514","147":"573c99ba"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1,"9":1,"10":1,"18":1,"19":1,"21":1,"22":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"48":1,"49":1,"52":1,"53":1,"54":1,"55":1,"60":1,"61":1,"63":1,"74":1,"78":1,"79":1,"91":1,"100":1,"101":1,"102":1,"108":1,"112":1,"113":1,"114":1,"116":1,"117":1,"125":1,"126":1,"132":1,"135":1,"136":1,"140":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"14":"ExamBoostAnimation","15":"NoWrongAnswersAnimation","16":"quiz-animation","17":"transfer-subscription-no-children-animation","27":"ChatbotQuitAnimation","28":"ChatbotTypingAnimation","29":"FloralRewardAnimation","30":"NoClassesAnimation","31":"SenecaPremiumCardAnimation","32":"accept-challenge-animation","33":"adam-image","34":"all-child-assignments","35":"anonymous-course-discovery-chunk","36":"anonymous-resources-hub","37":"anonymous-resources-hub-chunk","38":"anonymous-what-is-premium-parent","39":"anonymous-what-is-premium-teacher","40":"assignment-complete-animation","41":"assignment-share-animation","42":"ben-image","43":"calendar-image","44":"car-animation","45":"child-connected-modal","46":"child-connection-invite-journey","47":"child-not-found-route","48":"child-overview-page","49":"child-single-assignment","50":"child-sub-router","51":"circle-books-animation","52":"claim-tutoring-journey","53":"class-page-router","54":"classes-page","55":"classroom-chunk","56":"clock-animation","57":"confetti-animation","58":"correct-answer-animation","59":"courses-page","60":"courses-page-chunk","61":"creation-chunk","62":"cute-whale-animation","63":"dashboard-router-chunk","64":"date-fns-de","65":"date-fns-de-AT","66":"date-fns-en-AU","67":"date-fns-en-GB","68":"date-fns-en-IN","69":"date-fns-en-US","70":"date-fns-es","71":"date-fns-fr","72":"date-fns-pt-BR","73":"date-fns-vi","74":"dev-tools","75":"empty-desk-animation","76":"falling-confetti-animation","77":"feedback-success-animation","78":"front-door-chunk","79":"get-premium-chunk","80":"gostudent-logo-animation","81":"invite-all-school-parents","82":"invite-classes-parents-animation","83":"jane-image","84":"join-group-animation","85":"link-animation","86":"loading-blocks-animation","87":"magnifying-glass-animation","89":"medal-animation","90":"mia-image","91":"mobile-auth","92":"more-sub-router","93":"mumsnet-image","94":"new-courses-chunk","95":"no-assignments-animation","96":"no-course-info-animation","97":"no-study-time-animation","98":"noStudentsAssignmentsAnimation","99":"parent-claim-tutoring-journey-routes","100":"parent-dashboard","101":"parent-tutoring-page","102":"parent-what-is-premium-page","103":"parents-invite-route","104":"personalised-suggestions-courses-chunk","105":"plug-in-failed-animation","106":"plurall-help-centre-modal-chunk","107":"podium-animation","108":"progress-page","109":"receive-gift-open-animation","111":"sad-look-animation","112":"section-preview","113":"session","114":"settings-page","115":"share-animation","116":"share-assignment-chunk","117":"sign-up-invite-chunk","118":"sleepy-animation","119":"smiling-with-hearts-animation","120":"speedyMarkingQuitAnimation","121":"speedyMarkingSuccessAnimation","122":"spinning-trophy-animation","123":"success-animation","124":"target-animation","125":"teacher-dashboard","126":"topic-score-animation","127":"transfer-subscription-error-animation","128":"transfer-subscription-success-animation","129":"trash-animation","130":"trophy-animation","131":"trustpilot-image","132":"try-a-module","133":"tutoring-activation-journey","134":"unlock-dark-mode-chunk","135":"weekly-reports-page","136":"what-is-premium-chunk","137":"workout-animation"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"e8fbe97e","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"95274648","10":"071f5736","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"32daf4cf","19":"24c8c25e","20":"31d6cfe0","21":"50af7378","22":"6c6494c9","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"26dbc8e4","35":"66ea5b0b","36":"c49fae07","37":"c8578852","38":"eae05a40","39":"eae05a40","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"6f2678f0","49":"231ed436","50":"31d6cfe0","51":"31d6cfe0","52":"04d055db","53":"bb9ef516","54":"db5294cb","55":"ffc5966c","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"7c6e63ff","61":"2a20757f","62":"31d6cfe0","63":"b33307de","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"ad4d543f","75":"31d6cfe0","76":"31d6cfe0","77":"31d6cfe0","78":"2f8b818c","79":"34d7fb9f","80":"31d6cfe0","81":"31d6cfe0","82":"31d6cfe0","83":"31d6cfe0","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"31d6cfe0","89":"31d6cfe0","90":"31d6cfe0","91":"d8705ad5","92":"31d6cfe0","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"31d6cfe0","99":"31d6cfe0","100":"6cbed9e7","101":"04d055db","102":"3501bb7b","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"31d6cfe0","108":"b3dbd5ee","109":"31d6cfe0","111":"31d6cfe0","112":"99e12122","113":"eedd3518","114":"0fca8682","115":"31d6cfe0","116":"c8e9dbe2","117":"2f8b818c","118":"31d6cfe0","119":"31d6cfe0","120":"31d6cfe0","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"8d5045d4","126":"5a2bdb39","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"7964e5fa","133":"31d6cfe0","134":"31d6cfe0","135":"294d18fc","136":"7cae917b","137":"31d6cfe0","139":"31d6cfe0","140":"5d9248fe","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpseneca-web"] = this["webpackJsonpseneca-web"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
